module.exports = __webpack_public_path__ + "img/home-top.2557ed40.png";